import {
  Circle,
  CircleCheck,
  CircleDashed,
  CircleX,
  LoaderCircle,
  TriangleAlert,
} from 'lucide-react';
import React from 'react';

import type { PreviewSaveStatus } from './setting-preview.types';

/** Maps a save status to its corresponding icon with appropriate color. */
export const SaveStatusIcon = ({ status }: { status: PreviewSaveStatus }): React.ReactElement => {
  switch (status) {
    case 'validation-warning':
      return (
        <TriangleAlert
          className="glyph glyph-lg text-warning"
          aria-hidden="true"
          data-component="SaveStatusIcon"
        />
      );
    case 'pending':
      return (
        <div
          className="flex items-center justify-center rounded-full"
          data-component="SaveStatusIcon"
        >
          <LoaderCircle
            className="glyph glyph-lg animate-spin text-muted-foreground"
            aria-label="Saving"
          />
        </div>
      );
    case 'failed':
      return (
        <CircleX
          className="glyph glyph-lg text-ckds-text-fg-bad"
          aria-label={'Failed'}
          data-component="SaveStatusIcon"
        />
      );
    case 'cancelled':
      return (
        <CircleX
          className="glyph glyph-lg text-ckds-text-fg-tier3"
          aria-label={'Cancelled'}
          data-component="SaveStatusIcon"
        />
      );
    case 'completed':
      return (
        <CircleCheck
          className="glyph glyph-lg text-ckds-text-fg-good"
          aria-label="Completed"
          data-component="SaveStatusIcon"
        />
      );
    case 'queued':
      return (
        <CircleDashed
          className="glyph glyph-lg text-muted-foreground"
          aria-label="Queued"
          data-component="SaveStatusIcon"
        />
      );
    default:
      return (
        <Circle
          className="glyph glyph-lg bg-transparent stroke-input stroke-1"
          aria-hidden="true"
          data-component="SaveStatusIcon"
        />
      );
  }
};
